import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

export const InitChart = () => {
    ChartJS.register(
        CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend
    );
    ChartJS.defaults.font = {
        size : 14,
        family : 'Sarabun '
    }
}

export const barChartOptions = (title) => ({
    responsive: true,
    plugins: {
        legend: {
            position: 'right',
        },
        title: {
            display: true,
            text: title,
            font : {
                size : 16,
            }
        },
    },  
    scales : {
        x : {
            grid : {
                display : false
            }
        },
        y : {
            ticks: {
                callback: function(value, index, ticks) {
                    return value + ' คน';
                }
            }
        }
    }  
})

export const verticalBarChartOptions = (title) => ({
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: {
            display : false,
            position: 'right',
        },
        title: {
            display: true,
            text: title,
            font : {
                size : 16,
            }
        },
        grid : {
            display : false
        }
    },
    scales : {
        y : {
            grid : {
                display : false
            },
        },
        x : {
            title : {
                display : true,
                text : 'จำนวนคน',
                align : 'end'
            },

        }

    }
})


